export const iconFontAwesomeMusicVideoRecordVinyl = (
	<i className="fa-solid fa-record-vinyl"></i>
);
